export { default as CurrencyFormatted } from './CurrencyFormatted';
